import { httpInit } from "./http";

const http = httpInit("/consulting/role");

//分页查询角色
export const getRoleList = params => http.get(`/list/${params.conditions}`);

